export interface WelcomeCopy {
  name: string;
  title: string;
  welcomePageContent: string;
  welcomeCta: string;
  agreement?: {
    sys: {
      id: string;
      publishedVersion: number;
    };
    title: string;
    body: string;
  };
  agreementIntro: string;
  url: string;
  splashMedia: {
    contentType: string;
    url: string;
  };
}

const emptyCopy: WelcomeCopy = {
  name: '',
  title: '',
  welcomePageContent: '',
  welcomeCta: 'Continue',
  agreementIntro: '',
  url: '',
  splashMedia: { contentType: '', url: '' },
};

export const usePartnershipWelcomeContentQuery = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _slug: string,
): { isLoading: boolean; content: WelcomeCopy } => ({
  isLoading: false,
  content: emptyCopy,
});
